import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { MissionVisionSection } from './components/MissionVisionSection';
import { StatsSection } from './components/StatsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 scroll-smooth" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <WhyChooseUsSection data-id="element-5" />
        <HowItWorksSection data-id="element-6" />
        <MissionVisionSection data-id="element-7" />
        <StatsSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ContactSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <WhatsAppButton data-id="element-12" />
    </div>;
}